import isValidIdentifier from "helpers/isValidIdentifier";
import fetchInvitesQuery from "graphql/queries/invites/fetchInvites.graphql"

const revokeInviteFunction = (organisationId) => {
    return (store, {data}) => {
        try {
            const revokeInvite = typeof data["revokeInvite"] !== "undefined" ?
                data["revokeInvite"] : null;

            if (revokeInvite) {
                const { id } = revokeInvite;
                if (isValidIdentifier(id)) {
                    const data = store.readQuery({
                        query: fetchInvitesQuery,
                        variables: {organisationId}
                    });

                    const { invites } = data;
                    const updatedInvites = invites.map((invite) => {
                        if (invite.id === id) {
                            return revokeInvite;
                        }
                        return invite;
                    });

                    store.writeQuery({
                        query: fetchInvitesQuery,
                        variables: { organisationId },
                        data: {invites: updatedInvites}
                    });
                }
            }
        } catch (error) {
        }
    };
};

export default revokeInviteFunction;
